import { useMutation as e, useQueryClient as t } from "@maat/store-hooks";
import { usersApi as n } from "@maat/api-main";
import { authQueryKeys as r } from "@maat/store-auth";
//#region src/profile/useRemoveAvatarMutation.ts
var i = () => {
	let i = t();
	return e({
		mutationFn: () => n.removeAvatar(),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: r.state() }), i.invalidateQueries({ queryKey: r.me() });
		}
	});
};
//#endregion
export { i as useRemoveAvatarMutation };
